function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-465 -80) translate(0 64) translate(465 16)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M21.023 13.953c-1.644 0-2.976-1.332-2.976-2.976S19.379 8 21.023 8 24 9.333 24 10.977s-1.333 2.976-2.977 2.976zm1.86.373v6.697c0 1.644-1.332 2.977-2.976 2.977h-8.93C9.333 24 8 22.667 8 21.023v-8.93c0-1.644 1.333-2.977 2.977-2.977h6.697c-.325.433-.558.939-.67 1.489h-6.027c-.822 0-1.489.666-1.489 1.488v8.93c0 .822.667 1.489 1.489 1.489h8.93c.822 0 1.488-.667 1.488-1.489v-6.028c.55-.111 1.056-.344 1.489-.67z",
  transform: "translate(-465 -80) translate(0 64) translate(465 16)"
})))));

var SvgWhiteStatus = function SvgWhiteStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white_status.6415f8d3.svg";
export { ForwardRef as ReactComponent };